<template>
    <div>
        <el-form :model="urlInfo" ref="ruleForm" label-width="140px" class="demo-ruleForm">
            <el-form-item label="显示链接：" prop="page" class="pageSelect" require>
                <el-input placeholder="推广链接" type="text" v-model="urlInfo.show_url" @change="setMsg"></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        props:['showUrlMsg'],
        data () {
            return {
                urlInfo:{...this.showUrlMsg}
            }
        },
        components:{
        },
        methods: {
            setMsg(){
                this.$emit('getShowUrlMsg',this.urlInfo)
            },
        },
        watch: {
            showUrlMsg:{
                handler(){
                    this.urlInfo = {...this.showUrlMsg}
                },
                deep:true
            },
        }
    }
</script>
<style lang="scss">
    
</style>